import { Button, Form, Modal, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteBrand } from "../../../../api/brands";

const DeleteBrand = ({ isVisible, setVisible, selected, setSelected }: any) => {
  const { id } = selected;
  const queryClient = useQueryClient();

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: deleteBrand,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Deleted Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["brands"] });
      setVisible(false);
    },
  });

  const onSubmit = async () => {
    mutate({ id });
  };

  return (
    <>
      <Modal
        title="Delete Brand"
        open={isVisible}
        onCancel={() => setVisible(false)}
        footer={[
          <Button key="back" onClick={() => setVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            form="deleteBrand"
            htmlType="submit"
            onSubmit={onSubmit}
            loading={isLoading}
            className="border-0 bg-blue-600 text-white"
          >
            Delete
          </Button>,
        ]}
      >
        <Form
          id="deleteBrand"
          form={form}
          name="control-ref"
          onFinish={onSubmit}
          layout="vertical"
        >
          <div className="flex flex-col justify-center items-center">
            <div className="">
              Are you sure you want to
              <span className="text-red-600 px-1 font-bold">Delete</span>brand
            </div>
            <div className="font-bold">{selected?.name} ?</div>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default DeleteBrand;
